define('models/member/login',[
    'underscore', 'backbone', 'utils',
], function(
    _, Backbone, U
) {

    var MLogin = Backbone.Model.extend({
        defaults: {
            username: "",
            password: "",
        },
        getUser: function() {
            return this.get('username');
        },
        getPass: function() {
            return this.get('password');
        },

        validation: {
            username: { presence: true, },
            password: { presence: true, },
        },

    });

    return MLogin;
});

